import React, { FC } from 'react';
import { Modal } from 'antd';
import { ReactComponent as Injuries_notesIcon } from '../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg';
import { ReactComponent as CloseIcon } from 'src/assets/images/trainer/clients/close.svg';
import './InjuriesNotesModal.scss';

interface InjuriesNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  injuriesParts: string[];
  injuriesNotes?: string;
  injuryIconMapping: Record<string, React.ReactNode>;
  toTitleCase: (str: string) => string;
}

export const InjuriesNotesModal: FC<InjuriesNotesModalProps> = ({
  isOpen,
  onClose,
  injuriesParts,
  injuriesNotes,
  injuryIconMapping,
  toTitleCase,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={540}
      rootClassName="injuries-notes-list-modal"
      closeIcon={<CloseIcon className="modal-close-icon" />}
    >
      <div className="injuries-notes-modal-content">
        <div className="modal-header">
          <div className="header-left">
            <div className="header-icon">
              <Injuries_notesIcon />
            </div>
            <div className="header-text">
              <h3>Injuries & Notes</h3>
              <span className="subtitle">
                {injuriesParts.length > 0
                  ? `${injuriesParts.length} injuries & limitations recorded`
                  : 'Client injury profile & special notes'}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-section">
          <h4 className="section-title">Injuries & Limitations</h4>
          {injuriesParts.length > 0 ? (
            <div className="injuries-grid">
              {injuriesParts.map((part, idx) => (
                <div key={idx} className="injury-item-card">
                  <span className="injury-name">{toTitleCase(part)}</span>
                  <div className="injury-icon-wrapper">{injuryIconMapping[part]}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-section-text">None recorded</div>
          )}
        </div>

        <div className="modal-section notes-section">
          <h4 className="section-title">Special Notes</h4>
          <div className="notes-box">
            {injuriesNotes && injuriesNotes.trim() ? (
              <p className="notes-text">{injuriesNotes}</p>
            ) : (
              <p className="notes-empty">No special notes provided</p>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};
